import 'ladda/dist/ladda.min.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';

import 'ladda/dist/spin.min.js';
import Ladda from 'ladda/dist/ladda.min.js';
import L from 'leaflet/dist/leaflet.js';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.js';
import async from 'async';
import Page from '../../../js/Page';
import { setTimeout } from 'timers';


var PontoMovelCercas = (function () {

    var map;
    var drawnItems;
    var _mapCamposGeolocalizacao = {
        latitudeField: "ctl00$Main$CERCA$LATITUDE_HiddenField",
        longitudeField: "ctl00$Main$CERCA$LONGITUDE_HiddenField",
        radiusField: "ctl00$Main$CERCA$RAIO_HiddenField"
    };

    var assignIfIsValidFieldMap = function (mapCamposGeolocalizacao) {
        if (!mapCamposGeolocalizacao)
            return;

        var requiredFields = Objects.getOwnPropertyNames(_mapCamposGeolocalizacao);
        var existingFields = Objects.getOwnPropertyNames(mapCamposGeolocalizacao);

        var isValid = true;
        for (var i = 0; i < requiredFields.length; i++) {
            var possuiCampo = false;
            var currRequiredField = requiredFields[i];

            for (var j = 0; j < existingFields.length; j++) {
                var currExistingField = existingFields[j];
                if (currRequiredField === currExistingField) {
                    possuiCampo = true;
                    break;
                }
            }

            if (!possuiCampo) {
                isValid = false;
                break;
            }
        }

        if (isValid)
            _mapCamposGeolocalizacao = mapCamposGeolocalizacao;
    };

    var initImplementation = function (arrHandlesCercasIniciais, escondidoNaInicializacao, mapCamposGeolocalizacao) {

        assignIfIsValidFieldMap(mapCamposGeolocalizacao);

        map = L.map("map");
        drawnItems = new L.FeatureGroup();
        map.addLayer(drawnItems);

        var drawOptions = {
            draw: {
                circlemarker: false,
                polyline: false,
                circle: {
                    limit: 1, // limite de um círculo desenhável
                    showRadius: true,
                    metric: "metric"
                },
                polygon: false,
                rectangle: false,
                polyline: false,
                marker: false,
            },
            edit: {
                featureGroup: drawnItems
            }
        };

        var drawControl = new L.Control.Draw(drawOptions);
        map.addControl(drawControl);

        navigator.geolocation.getCurrentPosition(
            function (data) {
                map.setView([data.coords.latitude, data.coords.longitude], 14);
            },
            function (error) {
                console.error(error);
            }
        );

        mostrarMapaImplementation();

        var campolatField = document.getElementsByName(_mapCamposGeolocalizacao.latitudeField)[0];
        var campolngField = document.getElementsByName(_mapCamposGeolocalizacao.longitudeField)[0];
        var campoRadiusField = document.getElementsByName(_mapCamposGeolocalizacao.radiusField)[0];

        var possuiGeolocalizacaoVazia = campolatField == null || campolngField == null || campoRadiusField == null ||
            campolatField.value == "" || campolngField.value == "" || campoRadiusField.value == "";

        var possuiGeolocalizacaoValida = campolatField != null && campolngField != null && campoRadiusField != null &&
            campolatField.value != "" && campolngField.value != "" && campoRadiusField.value != "";


        if ((!arrHandlesCercasIniciais || arrHandlesCercasIniciais.length == 0) && possuiGeolocalizacaoVazia) {
            if (escondidoNaInicializacao)
                ocultarMapaImplementation();
        }

        if (arrHandlesCercasIniciais && arrHandlesCercasIniciais.length > 0) {
            cercaExistenteOnChangedImplementation(arrHandlesCercasIniciais);
        } else {
            if (possuiGeolocalizacaoValida) {

                let latField = campolatField.value;
                let lngField = campolngField.value;
                let radiusField = campoRadiusField.value;

                mostrarMapaImplementation();
                var location = L.latLng(latField, lngField); // latitude e longitude da localização existente
                map.setView(location, 16);

                var circle = L.circle(location, {
                    radius: radiusField, // raio em metros
                    color: '#3388ff', // cor da borda                            
                    fillColor: '#3388ff', // cor de preenchimento
                    fillOpacity: 0.2 // opacidade do preenchimento
                }).addTo(map);

                var bounds = circle.getBounds();
                map.fitBounds(bounds);

            }
        }

        map.on('draw:created', function (e) {
            limparMapaImplementation();
        });

        map.on('draw:deleted', function (e) {
            var layers = e.layers;
            layers.eachLayer(function (layer) {
                if (layer instanceof L.Circle) {
                    limparCamposLatLongImplementation();
                }
            });
        });

        map.on(L.Draw.Event.CREATED, function (event) {
            var layer = event.layer;
            drawnItems.addLayer(layer);

            var latlng = layer.getLatLng();
            var radius = layer.getRadius();


            var bounds = layer.getBounds();
            map.fitBounds(bounds);

            var latField = document.getElementsByName(_mapCamposGeolocalizacao.latitudeField)[0];
            var lngField = document.getElementsByName(_mapCamposGeolocalizacao.longitudeField)[0];
            var radiusField = document.getElementsByName(_mapCamposGeolocalizacao.radiusField)[0];

            // Define o valor dos campos de texto com as propriedades do circle
            latField.value = latlng.lat;
            lngField.value = latlng.lng;
            radiusField.value = radius;
        });

        map.on('draw:edited', function (e) {
            e.layers.eachLayer(function (layer) {
                if (layer instanceof L.Circle) {
                    var latlng = layer.getLatLng();
                    var radius = layer.getRadius();

                    var latField = document.getElementsByName(_mapCamposGeolocalizacao.latitudeField)[0];
                    var lngField = document.getElementsByName(_mapCamposGeolocalizacao.longitudeField)[0];
                    var radiusField = document.getElementsByName(_mapCamposGeolocalizacao.radiusField)[0];

                    latField.value = latlng.lat;
                    lngField.value = latlng.lng;
                    radiusField.value = radius;
                }
            });
        });
    }

    var definirMapaReadOnlyImplementation = function () {
        if (map) {
            map.dragging.disable();
        } else {
            setTimeout(definirMapaReadOnlyImplementation, 250);
            return;
        }

        if (document.getElementsByClassName("leaflet-draw leaflet-control")[0] != null)
            document.getElementsByClassName("leaflet-draw leaflet-control")[0].style.display = 'none'
    }

    var permitirEdicaoMapaImplementation = function () {
        if (map) {
            map.dragging.enable();
        } else {
            setTimeout(permitirEdicaoMapaImplementation, 250);
            return;
        }

        if (document.getElementsByClassName("leaflet-draw leaflet-control")[0] != null)
            document.getElementsByClassName("leaflet-draw leaflet-control")[0].style.display = 'block'
    }

    var posicaoRegistroAtualImplementation = function (handle) {
        limparMapaImplementation();
        var campolatField = document.getElementsByName(_mapCamposGeolocalizacao.latitudeField)[0];
        var campolngField = document.getElementsByName(_mapCamposGeolocalizacao.longitudeField)[0];
        var camporadiusField = document.getElementsByName(_mapCamposGeolocalizacao.radiusField)[0];

        if (campolatField != null && campolngField != null && camporadiusField != null) {
            var latField = campolatField.value;
            var lngField = campolngField.value;
            var radiusField = camporadiusField.value;

            var location = L.latLng(latField, lngField); // latitude e longitude da localização existente
            map.setView(location, 16);

            var circle = L.circle(location, {
                radius: radiusField, // raio em metros
                color: '#3388ff', // cor da borda                            
                fillColor: '#3388ff', // cor de preenchimento
                fillOpacity: 0.2 // opacidade do preenchimento
            }).addTo(map);

            var bounds = circle.getBounds();
            map.fitBounds(bounds);

            definirMapaReadOnlyImplementation();
        }
    }

    var cercaExistenteOnChangedImplementation = function (arrHandlesSelecionados) {
        if (!arrHandlesSelecionados || arrHandlesSelecionados.length == 0) {
            ocultarMapaImplementation();
        }
        else {
            AGA.Ajax.callWebMethodBlocked("RetornarLocalizacaoCercaSelecionada", { "handlesCercas": arrHandlesSelecionados },
                function (responseOriginal) {
                    limparMapaImplementation();
                    mostrarMapaImplementation();
                    var response = responseOriginal.d;

                    for (let i = 0; i < response.length; i++) {
                        var location = L.latLng(response[i].Latitude, response[i].Longitude); // latitude e longitude da localização existente
                        map.setView(location, 16);

                        L.circle(location, {
                            radius: response[i].Raio, // raio em metros
                            color: '#3388ff', // cor da borda                            
                            fillColor: '#3388ff', // cor de preenchimento
                            fillOpacity: 0.2 // opacidade do preenchimento,

                        }).bindTooltip(response[i].Nome,
                            {
                                permanent: true, // define se a legenda é permanente ou aparece apenas ao passar o mouse sobre o círculo
                                direction: 'center', // posição da legenda em relação ao círculo
                                className: 'my-tooltip', // nome da classe CSS para customizar a legenda
                                offset: L.point(0, 10), // define um deslocamento para a posição da legenda
                                opacity: 0.8, // opacidade da legenda
                                fillColor: 'white', // cor do fundo da legenda
                                fontColor: 'black', // cor do texto da legenda
                                fontSize: '12px' // tamanho da fonte da legenda
                            }).addTo(drawnItems);

                        var bounds = drawnItems.getBounds();
                        map.fitBounds(bounds);
                    }

                    definirMapaReadOnlyImplementation();

                    document.getElementById("AreaMapa").style.display = 'block';

                },
                function (error) {
                    console.error(error);
                });
        }
    }

    var limparMapaImplementation = function () {
        document.getElementsByClassName("leaflet-draw leaflet-control")[0].style.display = 'block'

        drawnItems.clearLayers();
        map.eachLayer(function (layer) {
            if (layer instanceof L.Circle) {
                map.removeLayer(layer);
            }
        });
    }

    var limparCamposLatLongImplementation = function () {
        document.getElementsByName(_mapCamposGeolocalizacao.latitudeField)[0].value = "";
        document.getElementsByName(_mapCamposGeolocalizacao.longitudeField)[0].value = "";
        document.getElementsByName(_mapCamposGeolocalizacao.radiusField)[0].value = "";
    }

    var mostrarMapaImplementation = function () {
        document.querySelector('#map').removeAttribute('hidden');

        map.invalidateSize();
        var layer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:
                'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors',
            maxZoom: 18,
        }).addTo(map);
        layer.redraw();
    };

    var setarPosicaoAtualImplementation = function () {
        limparMapaImplementation();
        navigator.geolocation.getCurrentPosition(
            function (data) {
                map.setView([data.coords.latitude, data.coords.longitude], 14);
            },
            function (error) {
                console.error(error)
            });
    }

    function buscarEnderecoImplementation(address) {
        AGA.Ajax.callWebApiBlocked(
            "api/v1/RH/Ponto/Geolocalizacao/Coordenadas",
            {
                endereco: address
            },
            (resp) => {
                if (!resp.StatusOk) {
                    AGA.Helper.alert(resp.MessageException);
                    return;
                }

                let coordenadas = resp.Content;

                map.setView([coordenadas.Latitude, coordenadas.Longitude], 17);
            },
            (error) => {
                console.error(error);
            }
        );

    }

    var ocultarMapaImplementation = function () {
        limparMapaImplementation();
        document.querySelector('#map').setAttribute('hidden', 'true');
    };

    return {
        Init: initImplementation,
        LimparMapa: limparMapaImplementation,
        MostrarMapa: mostrarMapaImplementation,
        OcultarMapa: ocultarMapaImplementation,
        SetarPosicaoAtual: setarPosicaoAtualImplementation,
        SetarPosicaoRegistroAtual: posicaoRegistroAtualImplementation,
        PermitirEdicaoMapa: permitirEdicaoMapaImplementation,
        DefinirMapaReadOnly: definirMapaReadOnlyImplementation,
        CercaExistenteOnChanged: cercaExistenteOnChangedImplementation,
        BuscarEndereco: buscarEnderecoImplementation,
        LimparCampos: limparCamposLatLongImplementation
    }
}());

export default PontoMovelCercas;